module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7YeWZ"))).then(() => parcelRequire('3a9aZ'));